import { readOnly } from '@ember/object/computed';

import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { CMS_LANGUAGE_IDS } from 'umg-ember-backend/utils/cms-languages';
import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  cmsLanguageId: validator('inclusion', { in: CMS_LANGUAGE_IDS }),
  title: validator('presence', true),
  startDate: [
    validator('presence', true),
    validator('date', {
      errorFormat: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      },
      locale: 'de',
    }),
  ],
  endDate: [
    validator('presence', true),
    validator('date', {
      after: readOnly('model.startDate'),
      errorFormat: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      },
    }),
  ],
  deleteDate: [
    validator('presence', true),
    validator('date', {
      after: readOnly('model.endDate'),
      errorFormat: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      },
      locale: 'de',
    }),
  ],
  terms: [validator('belongs-to'), validator('presence', true)],
  legalContext: [validator('belongs-to'), validator('presence', true)],
  newsletterTarget: [
    validator('belongs-to'),
    validator('matching-legal-context', {
      dependentKeys: ['model.legalContext'],
      messageKey: 'errors.matchingLegalContext',
    }),
  ],
  keepWinners: validator('inclusion', {
    in: [true, false],
  }),
});

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('formFields')],
  },
};

export default class ContestModel extends Model.extend(Validations) {
  @attr('string') title;
  @attr('sql-date-time') startDate;
  @attr('sql-date-time') endDate;
  @attr('sql-date-time') deleteDate;
  @attr('string') ctaButton;
  @attr('string') confirmationText;
  @attr('boolean', { defaultValue: false }) keepWinners;
  @attr('string', { defaultValue: '1' }) cmsLanguageId;

  @hasMany('contest-form-field', { async: true, inverse: 'contest' })
  formFields;
  @belongsTo('asset', { async: true, inverse: null }) terms;
  @belongsTo('organization', { async: true, inverse: null }) legalContext;
  @belongsTo('newsletter-target', { async: true, inverse: null })
  newsletterTarget;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter and setter
  get displayHeadline() {
    return this.title;
  }

  get displayLabel() {
    return this.title;
  }
}
